import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useAddDeposit } from 'src/context/deposit';
import { cn } from 'src/lib/utils';

import OAuthDepositContainer from './Methods/OAuthDepositContainer';
import CustomDepositContainer from './Methods/CustomDepositContainer';
import RepoUploadContainer from './Methods/RepoUploadContainer';
import SecureUploadContainer from './Methods/SecureUploadContainer';
import SelectDepositMethodContainer from './Steps/SelectDepositMethodContainer';
import OAuthDepositConfirmContainer from './Steps/OAuthDepositConfirmContainer';
import CustomDepositConfirmContainer from './Steps/CustomDepositConfirmContainer';
import RepoUploadVerificationFailedContainer from './Steps/RepoUploadVerificationFailedContainer';

const addStepMap: Record<string, { modalWidth: string; component: React.ComponentType; contentClassName?: string }> = {
  'select-method': {
    modalWidth: 'sm:max-w-[976px]',
    component: SelectDepositMethodContainer,
    contentClassName: 'gap-0 p-0 grid-rows-[auto_1fr_auto] max-h-[820px] min-h-0',
  },
  custom: {
    modalWidth: 'sm:max-w-[976px]',
    component: CustomDepositContainer,
    contentClassName: 'p-0 grid-rows-[auto_1fr_auto] max-h-[769px] min-h-0',
  },
  oauth: {
    modalWidth: 'sm:max-w-[976px]',
    component: OAuthDepositContainer,
    contentClassName: 'p-0 grid-rows-[auto_1fr_auto] max-h-[820px] min-h-0',
  },
  secure: {
    modalWidth: 'sm:max-w-[600px]',
    component: SecureUploadContainer,
    contentClassName: 'max-h-[820px] overflow-y-auto',
  },
  repo: {
    modalWidth: 'sm:max-w-[600px]',
    component: RepoUploadContainer,
    contentClassName: 'max-h-[820px] overflow-y-auto',
  },
  'repo-verification-failed': {
    modalWidth: 'sm:max-w-[600px]',
    component: RepoUploadVerificationFailedContainer,
  },
  'oauth-confirm': {
    modalWidth: 'sm:max-w-[600px]',
    component: OAuthDepositConfirmContainer,
    contentClassName: 'p-0 grid-rows-[auto_1fr_auto] max-h-[820px] min-h-0',
  },
  'custom-confirm': {
    modalWidth: 'sm:max-w-[600px]',
    component: CustomDepositConfirmContainer,
    contentClassName: 'p-0 grid-rows-[auto_1fr_auto] max-h-[820px] min-h-0',
  },
};

const AddDepositContainer = () => {
  const {
    ui: { step, setInitialData },
    refetch,
  } = useAddDeposit();

  const activeStep = addStepMap[step as keyof typeof addStepMap];
  const StepComponent = activeStep?.component;

  const onOpenChange = (open: boolean) => {
    if (open) return;
    refetch?.();
    setInitialData();
  };

  return (
    <Dialog open={Boolean(step)} onOpenChange={onOpenChange}>
      <DialogContent className={cn('gap-6', activeStep?.modalWidth, activeStep?.contentClassName)}>
        {StepComponent && <StepComponent />}
      </DialogContent>
    </Dialog>
  );
};

export default AddDepositContainer;
